import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  getDeglawyContentById, getDeglawyContents, updateDeglawyContent,
} from '../../axios/deglawyRequests';
import {
  uploadFileURL,
} from '../../axios/requests';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  uploadFile,
} from '../../helperFunctions/uploadService';
import {
  DeglawyContent, IDeglawyContentStore, Media,
} from '../storeInterfaces/deglawyContentInterface';
import { RequestStatus } from "mobx-store";

export class DeglawyContentStore implements IDeglawyContentStore {
  @observable deglawyContentsList: DeglawyContent[] = [];

  @observable selectedDeglawyContent = new DeglawyContent();

  @observable loading = false;

  @observable iframePointsState = RequestStatus.IDLE;
  @observable payPointsState = RequestStatus.IDLE;

  @observable error = "Something wentwrong";

  @observable iframePoints: {
    amount: number;
    points: number;
  } = {
    amount: 0,
    points: 0,
  };

  updateDeglawyContentById(
    updatedDeglawyContent: any,
    id: number,
    languageCode?: string | undefined
  ): Promise<any> {
    throw new Error("Method not implemented.");
  }

  @action
  public async getDeglawyContents(
    languageCode: string = DefaultLanguage
  ): Promise<void> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(
        getDeglawyContents,
        getHeader(languageCode)
      );
      console.log(response);
      this.deglawyContentsList = this.restructureDeglawyContentsArray(
        response.data
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async getUserPointsInfoIframe(
    membershipId: string,
    cardsDeliveryFess: number
  ): Promise<void> {
    try {
      this.iframePointsState = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(
        `/deglawy/${membershipId}/points?cardsDeliveryFess=${cardsDeliveryFess}`
      );
      console.log("response.data", response.data);
      this.iframePoints = response.data;
      this.iframePointsState = RequestStatus.SUCCESS;
    } catch (error) {
      console.log(error);
      this.iframePointsState = RequestStatus.FAILED;
    }
  }

  @action
  public async payUserPointsInfoIframe(
    membershipId: string,
    cardsDeliveryFess: number,
    requestId: string
  ): Promise<void> {
    try {
      this.payPointsState = RequestStatus.LOADING;
      await Connections.wadiDeglaAxios.httpPost(
        `/orders/${membershipId}/pointsIframe?cardsDeliveryFess=${cardsDeliveryFess}&requestId=${requestId}`,
        {}
      );
      this.payPointsState = RequestStatus.SUCCESS;
    } catch (error) {
      const message = (error as any)?.response?.data?.message;
      if (message) this.error = message;
      this.payPointsState = RequestStatus.FAILED;
    }
  }

  private restructureDeglawyContentsArray(data: any): DeglawyContent[] {
    const incomingData: DeglawyContent[] = [];
    data.forEach((deglawyContent: any) => {
      const deglawyContentToPush: DeglawyContent = new DeglawyContent();
      deglawyContentToPush.setId(deglawyContent.deglawyContentId);
      deglawyContentToPush.setTitle(deglawyContent.title);
      incomingData.push(deglawyContentToPush);
    });
    return incomingData;
  }

  private restructureDeglawyContent(data: any): DeglawyContent {
    const structuredDeglawyContent: DeglawyContent = new DeglawyContent();
    structuredDeglawyContent.setId(data.deglawyContentId);
    structuredDeglawyContent.setBody(data.body);
    structuredDeglawyContent.setTitle(data.title);
    structuredDeglawyContent.setMedia(data.media);
    return structuredDeglawyContent;
  }

  @action
  public async getDeglawyContentById(
    id: number,
    languageCode: string = DefaultLanguage
  ): Promise<void> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(
        getDeglawyContentById(id),
        getHeader(languageCode)
      );
      this.selectedDeglawyContent = this.restructureDeglawyContent(
        response.data
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async updateDeglawyContent(
    updatedDeglawyContent: DeglawyContent,
    languageCode?: string | undefined
  ): Promise<any> {
    try {
      delete updatedDeglawyContent.title;
      // const headerImage = await this.uploadHeaderImage(updatedDeglawyContent.getHeaderImage());
      const media = await this.uploadHeaderImage(
        updatedDeglawyContent.getMedia()
      );
      const formatedMedia = media.map((m) => ({ url: m.imageUrl })) as Media[];
      // updatedDeglawyContent.setHeaderImage(headerImage);
      updatedDeglawyContent.setMedia(formatedMedia);
      const response = await Connections.wadiDeglaAxios.httpPut(
        updateDeglawyContent,
        {
          ...updatedDeglawyContent.getContentToUpdate(),
          languageCode,
        }
      );
    } catch (error) {
      throw error;
    }
  }

  private uploadHeaderImage(images: any[]) {
    const promises = [];
    const allImages: any[] = [];
    for (const image of images) {
      if (image.preview) {
        promises.push(
          uploadFile(uploadFileURL, image).then((res: any) => {
            allImages.push({
              imageUrl: res.data.downloadURL,
            });
          })
        );
      } else {
        allImages.push(image);
      }
    }
    return Promise.all(promises)
      .then(() => {
        console.log("done");
        return allImages;
      })
      .catch((error) => {
        console.log("error");
        return allImages;
      });
  }
}
